var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable } from 'mobx';
class LoadingTaskModel {
    id;
    title;
    done;
    total;
}
export default class LoadingTask extends LoadingTaskModel {
    constructor(modelData) {
        super();
        Object.keys(modelData).forEach((key) => {
            this[key] = modelData[key];
        });
    }
    get percentageOfCompletion() {
        return (this.done / this.total) * 100;
    }
    get isCompleted() {
        return this.percentageOfCompletion === 100;
    }
}
__decorate([
    observable
], LoadingTask.prototype, "id", void 0);
__decorate([
    observable
], LoadingTask.prototype, "title", void 0);
__decorate([
    observable
], LoadingTask.prototype, "done", void 0);
__decorate([
    observable
], LoadingTask.prototype, "total", void 0);
__decorate([
    computed
], LoadingTask.prototype, "percentageOfCompletion", null);
__decorate([
    computed
], LoadingTask.prototype, "isCompleted", null);
